import { render, staticRenderFns } from "./OrgChartTemp2.vue?vue&type=template&id=cdb93b6a&scoped=true&"
import script from "./OrgChartTemp2.vue?vue&type=script&lang=js&"
export * from "./OrgChartTemp2.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartTemp2.vue?vue&type=style&index=0&id=cdb93b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb93b6a",
  null
  
)

export default component.exports